var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { InternalMessageBusChannels, internalMessageBus } from "sb-internal-msg-bus";
import { Cookies } from "sb-helpers";
import { computed, action, observable } from "mobx";
import { FavoriteItem } from "../../typings";
// 1.5 hours
var EXPIRE_TIME = 0.063;
var FavoritesManager = /** @class */ (function () {
    function FavoritesManager(cookieName) {
        this.cookieName = cookieName;
        this.favorites = observable([]);
    }
    /* istanbul ignore next */
    // Cookies cannot be tested
    FavoritesManager.prototype.setCookie = function (favoriteEvents) {
        var favoritesCookie = favoriteEvents.map(function (favoriteEvent) { return favoriteEvent.stringify(); });
        Cookies.set(this.cookieName, favoritesCookie.join(","), { expires: EXPIRE_TIME });
    };
    /* istanbul ignore next */
    // Cookies cannot be tested
    FavoritesManager.prototype.getCookie = function () {
        var favoritesInCookie = Cookies.get(this.cookieName);
        var favorites = favoritesInCookie ? favoritesInCookie.split(",") : [];
        return favorites.map(function (favoritePair) { return new FavoriteItem(favoritePair); });
    };
    FavoritesManager.prototype.emitFavoritesMessage = function (option) {
        internalMessageBus.emit(InternalMessageBusChannels.favoriteEvents[option]);
    };
    Object.defineProperty(FavoritesManager.prototype, "favoriteEventIds", {
        get: function () {
            return this.favorites.map(function (item) { return item.eventId; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FavoritesManager.prototype, "favoriteSportIds", {
        get: function () {
            return this.favorites.map(function (item) { return item.sportId; })
                .filter(function (id, i, array) { return array.indexOf(id) === i; });
        },
        enumerable: true,
        configurable: true
    });
    FavoritesManager.prototype.add = function (eventToAdd) {
        this.favorites.push(eventToAdd);
        this.setCookie(this.favorites);
        this.emitFavoritesMessage("add");
    };
    FavoritesManager.prototype.remove = function (eventToRemove) {
        this.favorites.replace(this.favorites.filter(function (item) { return item.eventId !== eventToRemove.eventId; }));
        this.setCookie(this.favorites);
        this.emitFavoritesMessage("remove");
    };
    FavoritesManager.prototype.loadFavorites = function () {
        this.favorites.replace(this.getCookie());
    };
    FavoritesManager.prototype.manageFavorites = function (event) {
        var item = new FavoriteItem();
        item.setValues(event.sportId, event.id);
        this.isInFavorites(event.id) ? this.remove(item) : this.add(item);
    };
    FavoritesManager.prototype.isInFavorites = function (eventId) {
        return this.favorites.some(function (item) { return item.eventId === eventId; });
    };
    Object.defineProperty(FavoritesManager.prototype, "getFavorites", {
        get: function () {
            return this.favorites;
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        computed,
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [])
    ], FavoritesManager.prototype, "favoriteEventIds", null);
    __decorate([
        computed,
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [])
    ], FavoritesManager.prototype, "favoriteSportIds", null);
    __decorate([
        action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [FavoriteItem]),
        __metadata("design:returntype", void 0)
    ], FavoritesManager.prototype, "add", null);
    __decorate([
        action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [FavoriteItem]),
        __metadata("design:returntype", void 0)
    ], FavoritesManager.prototype, "remove", null);
    __decorate([
        action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], FavoritesManager.prototype, "loadFavorites", null);
    __decorate([
        computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], FavoritesManager.prototype, "getFavorites", null);
    return FavoritesManager;
}());
export { FavoritesManager };
//# sourceMappingURL=FavoritesManager.js.map